import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionsStore from '../../Store';
import withRouter from '../WithRouter';
import CurrentCollectionStep from '../Edit/CurrentCollectionStep';
import LearningCollectionReactions from '../Edit/Store/Reactions';
import LearningCollectionEditStore from '../Edit/Store';

interface Props {
  params: { id: string };
  store: LearningCollectionsStore;
}

class Invitations extends React.Component<Props, {}> {
  learningCollectionStore: LearningCollectionEditStore;

  constructor(props: Props) {
    super(props);
    this.learningCollectionStore = new LearningCollectionEditStore(props.store);
  }

  componentDidMount() {
    const { id } = this.props.params;
    this.learningCollectionStore.loadingForInvitations(id);
  }

  render() {
    return (
      <>
        <CurrentCollectionStep store={this.learningCollectionStore} />
        <LearningCollectionReactions store={this.learningCollectionStore} />
      </>
    );
  }
}

export default observer(withRouter(Invitations));
